var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.12,
    fillRule: "evenodd",
    d: "M0 16.676c0-8.837 7.163-16 16-16s16 7.163 16 16-7.163 16-16 16-16-7.164-16-16",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M22.668 11.175a2.17 2.17 0 0 1 1.509 1.55c.356 1.366.356 4.217.356 4.217s0 2.851-.356 4.218a2.17 2.17 0 0 1-1.51 1.55c-1.33.365-6.667.365-6.667.365s-5.337 0-6.668-.366a2.17 2.17 0 0 1-1.509-1.55c-.356-1.366-.356-4.217-.356-4.217s0-2.851.356-4.218a2.17 2.17 0 0 1 1.51-1.55C10.662 10.81 16 10.81 16 10.81s5.337 0 6.668.366M14.4 14.542v5.333l4.267-2.666z",
    clipRule: "evenodd"
  })));
};
export default SvgYoutube;